// extracted by mini-css-extract-plugin
export default {"vertical-menu":"VerticalMenu_vertical-menu__M5eIe","collapsed":"VerticalMenu_collapsed__z4FDy","open":"VerticalMenu_open__giiDc","icon":"VerticalMenu_icon__W1Ge2"};